module.exports = __webpack_public_path__ + "img/hands1.3df1a8d2.png";